import { type UseQueryResult, useQuery } from 'react-query';
import {
  SingIn2FaConfigurationService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AppServices__2FA_SingIn2FAConfigurationResponseDto,
} from '../../services/wealthlane-identity-services';

const useGetIsSingIn2FaEnabled = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AppServices__2FA_SingIn2FAConfigurationResponseDto | undefined,
  unknown
> => {
  return useQuery(['getIsSingIn2FaEnabled'], async () => {
    return await handleRequest(
      SingIn2FaConfigurationService.getApiIdentityApiSingIn2FaConfigurationIsSingIn2FaEnabled()
    );
  });
};

export default useGetIsSingIn2FaEnabled;
